export const dashboardEn = {
  welcomeTo: "Welcome to Floline",
  signInToStart: "Pain tracking made simple. Sign in to get started.",
  painHistory: "Pain History",
  recentEntries: "Your recent pain entries will appear here",
  signInToTrack: "Sign in to start tracking your pain history.",
  welcomeBack: "Welcome back, {{name}}",
  trackPatterns: "Track your pain, understand your patterns.",
  errorLoad: "Unable to load dashboard data. Please try again.",
  reloadPage: "Reload Page",

  // Week carousel
  thisWeek: "Last 7 Days",
  previousSlide: "Previous slide",
  nextSlide: "Next slide",
  swipeHint: "Swipe to view map, trends, and consistency",
  carouselSlides: "Carousel slides",
  carouselAriaLabel: "This week carousel with {{count}} slides",
  slideAriaLabel: "Slide {{current}} of {{total}}: {{label}}",
  slideAriaLabelCurrent: "Slide {{current}} of {{total}}: {{label}} (current)",
  goToSlide: "Go to slide {{index}}: {{label}}",
  showingSlide: "Showing {{label}}, slide {{current}} of {{total}}",

  // Slide labels
  slidePainMap: "This Week's Pain Map",
  slideTrend: "This Week's Trend",
  slideEvents: "This Week's Events",
  slideConsistency: "Weekly Consistency",

  // Heatmap slide
  front: "Front",
  back: "Back",
  noPainDataYet: "No pain data this week yet",
  mostAffected: "Most Affected",
  weeklyAvg: "Weekly Avg",
  day_one: "day",
  day_other: "days",
  bodyRegion: {
    head_neck: "Head/Neck",
    shoulder: "Shoulder",
    upper_back: "Upper Back",
    lower_back: "Lower Back",
    chest: "Chest",
    abdomen: "Abdomen",
    hip: "Hip",
    arm: "Arm",
    hand: "Hand",
    leg: "Leg",
    foot: "Foot",
    pelvis_groin: "Pelvis/Groin",
    generalized: "Generalized",
    other: "Other",
  },

  // Trends slide
  noTrendDataYet: "No trend data this week yet",
  startTrackingTrends: "Start tracking to see your weekly trends",
  trendChartAriaLabel: "Pain intensity trend chart for this week",
  daysTracked: "Days Tracked",
  averagePain: "Average Pain",
  peakPain: "Peak Pain",
  tracking: "Tracking",
  dailyAverageIntensity: "Daily average intensity",
  highestRecorded: "Highest recorded",
  daysWithRecords: "Days with records",
  viewFullTrends: "View full trends",
  noDataRecorded: "No data recorded",
  consistency: "{{percent}}% consistency",
  averagePainLineName: "Average Pain",

  // Consistency slide
  consistencySlideTitle: "Tracking rhythm",
  consistencySlideDescription: "How consistently you logged over the last 7 days",
  consistencyRate: "Consistency",
  consistencyDays: "{{logged}}/{{total}} days logged",
  currentStreakWeeks: "Current week streak",
  longestStreakWeeks: "Longest week streak",
  streakDays_one: "{{count}} day",
  streakDays_other: "{{count}} days",
  streakWeeks_one: "{{count}} week",
  streakWeeks_other: "{{count}} weeks",
  weekdayCoverage: "Weekday coverage",
  weekendCoverage: "Weekend coverage",
  weekdays: "Mon-Fri",
  noMissedDays: "No missed days",
  missedDaysCount_one: "{{count}} missed day",
  missedDaysCount_other: "{{count}} missed days",

  // Insights card
  insights: "Insights",
  viewAllInsights: "View all insights",
  moreInsights: "+{{count}} more",
  continueLogging: "Continue logging to see patterns in your data",
  insightsLoadFailed: "Unable to load insights. Please try again later.",
  dismissInsight: "Dismiss {{type}} insight",
  insightType: {
    trend_observation: "Trend",
    pattern_identification: "Pattern",
    correlation_observation: "Observation",
    progress_indicator: "Progress",
    focus_suggestion: "Suggestion",
  },

  // Quick actions card
  quickActions: "Quick Actions",
  dismissAction: "Dismiss {{title}}",
  quickAction: {
    prepareAppointmentTitle: "Prepare for Appointment",
    prepareAppointmentDescription: "Generate a summary report for your doctor",
    addCheckInTitle: "Add Today's Check-in",
    addCheckInDescription: "Log how you're feeling right now",
    voiceCheckInTitle: "Voice Check-in",
    voiceCheckInDescription: "Describe your symptoms using your voice",
    aiCheckInTitle: "AI Check-in",
    aiCheckInDescription: "Chat with AI to log your pain naturally",
    viewTrendsTitle: "View Your Trends",
    viewTrendsDescription: "See patterns in your pain data",
    logEventTitle: "Log an Event",
    logEventDescription: "Record a medication change, procedure, or milestone",
    setUpRemindersTitle: "Set Up Reminders",
    setUpRemindersDescription: "Get daily prompts to log your pain",
    addMedicationsTitle: "Add Your Medications",
    addMedicationsDescription: "Track medications to see how they affect your pain",
    completeProfileTitle: "Complete Your Profile",
    completeProfileDescription: "Add details to improve your pain insights",
    exportDataTitle: "Export Your Data",
    exportDataDescription: "Download your pain history for your doctor",
  },

  // Primary actions bar
  primaryActions: "Primary actions",
  primaryAction: {
    addCheckIn: "Check-in",
    addEvent: "Event",
    prepareAppointment: "Appointment",
    addCheckInLong: "Add a pain check-in",
    addEventLong: "Add a health event",
    prepareAppointmentLong: "Prepare for a doctor appointment",
    helpStartTracking: "Start tracking to prepare for appointments",
    helpDaysRemaining_one: "{{count}} more day of tracking for better insights",
    helpDaysRemaining_other: "{{count}} more days of tracking for better insights",
  },

  // Recent events card
  recentEvents: "Recent Events",
  viewAll: "View all",
  logFirstEvent: "Log First Event",
  ongoing: "Ongoing",
  positiveMilestonesThisMonth_one: "{{count}} positive milestone this month",
  positiveMilestonesThisMonth_other: "{{count}} positive milestones this month",

  // Today summary card
  noCheckInsToday: "No check-ins today",
  howAreYouFeeling: "How are you feeling today?",
  addCheckIn: "Add Check-in",
  lastCheckIn: "Last check-in: {{time}}",
  locationSingular: "Location",
  locationPlural: "Locations",
  avgIntensity: "Avg Intensity",

  // Today status banner
  todayStatusBanner: {
    default: {
      text: "You haven't logged today yet",
      cta: "Log how you're feeling",
      ariaLabel: "Reminder: You haven't logged today yet. Tap to add a pain check-in",
    },
    casual: {
      text: "How are you feeling today?",
      cta: "Add today's check-in",
      ariaLabel: "How are you feeling today? Tap to add your pain check-in",
    },
  },

  // Week summary card
  noDataYet: "No data yet",
  avg: "Avg: {{value}}",
  avgNoData: "Avg: —",
  daysLogged: "{{logged}} of {{total}} days logged",

  // Dashboard empty state
  welcomeUser: "Welcome to Floline, {{name}}",
  welcomeGeneric: "Welcome to Floline",
  emptyStateDescription: "Track your pain to discover patterns and share insights with your doctor.",
  startFirstCheckIn: "Start Your First Check-in",
  emptyStateGuidance: "Track your pain locations, intensity, and any medications you've taken",
} as const;

export const dashboardFi = {
  welcomeTo: "Tervetuloa Flolineen",
  signInToStart: "Kivun seuranta helposti. Kirjaudu aloittaaksesi.",
  painHistory: "Kipuhistoria",
  recentEntries: "Viimeisimmät kipukirjaukset näkyvät täällä",
  signInToTrack: "Kirjaudu sisään aloittaaksesi kipuhistorian seurannan.",
  welcomeBack: "Tervetuloa takaisin, {{name}}",
  trackPatterns: "Seuraa kipuasi, ymmärrä kuvioitasi.",
  errorLoad: "Koontinäytön lataus epäonnistui. Yritä uudelleen.",
  reloadPage: "Lataa sivu uudelleen",

  // Week carousel
  thisWeek: "Viimeiset 7 päivää",
  previousSlide: "Edellinen dia",
  nextSlide: "Seuraava dia",
  swipeHint: "Pyyhkäise nähdäksesi kartta, trendit ja johdonmukaisuus",
  carouselSlides: "Karusellin diat",
  carouselAriaLabel: "Tämän viikon karuselli, {{count}} diaa",
  slideAriaLabel: "Dia {{current}}/{{total}}: {{label}}",
  slideAriaLabelCurrent: "Dia {{current}}/{{total}}: {{label}} (nykyinen)",
  goToSlide: "Siirry diaan {{index}}: {{label}}",
  showingSlide: "Näytetään {{label}}, dia {{current}}/{{total}}",

  // Slide labels
  slidePainMap: "Viikon kipukartta",
  slideTrend: "Viikon trendi",
  slideEvents: "Viikon tapahtumat",
  slideConsistency: "Viikon johdonmukaisuus",

  // Heatmap slide
  front: "Edestä",
  back: "Takaa",
  noPainDataYet: "Ei kipudataa tältä viikolta vielä",
  mostAffected: "Eniten kipua",
  weeklyAvg: "Viikkokeskiarvo",
  day_one: "päivä",
  day_other: "päivää",
  bodyRegion: {
    head_neck: "Pää/Niska",
    shoulder: "Olkapää",
    upper_back: "Yläselkä",
    lower_back: "Alaselkä",
    chest: "Rintakehä",
    abdomen: "Vatsa",
    hip: "Lonkka",
    arm: "Käsi",
    hand: "Kämmen",
    leg: "Jalka",
    foot: "Jalkaterä",
    pelvis_groin: "Lantio/Nivunen",
    generalized: "Yleistynyt",
    other: "Muu",
  },

  // Trends slide
  noTrendDataYet: "Ei trendidataa tältä viikolta vielä",
  startTrackingTrends: "Aloita seuranta nähdäksesi viikkotrendit",
  trendChartAriaLabel: "Kipuintensiteetin trendikaavio tälle viikolle",
  daysTracked: "Seurantapäivät",
  averagePain: "Keskikipu",
  peakPain: "Huippukipu",
  tracking: "Seuranta",
  dailyAverageIntensity: "Päivittäinen keskiarvo",
  highestRecorded: "Korkein kirjattu",
  daysWithRecords: "Päivät, joilla kirjauksia",
  viewFullTrends: "Näytä kaikki trendit",
  noDataRecorded: "Ei kirjattua dataa",
  consistency: "{{percent}} % johdonmukaisuus",
  averagePainLineName: "Keskikipu",

  // Consistency slide
  consistencySlideTitle: "Kirjausrytmi",
  consistencySlideDescription: "Kuinka johdonmukaisesti kirjasit viimeisen 7 päivän aikana",
  consistencyRate: "Johdonmukaisuus",
  consistencyDays: "{{logged}}/{{total}} päivää kirjattu",
  currentStreakWeeks: "Nykyinen viikkoputki",
  longestStreakWeeks: "Pisin viikkoputki",
  streakDays_one: "{{count}} päivä",
  streakDays_other: "{{count}} päivää",
  streakWeeks_one: "{{count}} viikko",
  streakWeeks_other: "{{count}} viikkoa",
  weekdayCoverage: "Arkipäivien kattavuus",
  weekendCoverage: "Viikonlopun kattavuus",
  weekdays: "Ma-Pe",
  noMissedDays: "Ei väliin jääneitä päiviä",
  missedDaysCount_one: "{{count}} väliin jäänyt päivä",
  missedDaysCount_other: "{{count}} väliin jäänyttä päivää",

  // Insights card
  insights: "Oivallukset",
  viewAllInsights: "Näytä kaikki oivallukset",
  moreInsights: "+{{count}} lisää",
  continueLogging: "Jatka kirjaamista nähdäksesi kuvioita datassasi",
  insightsLoadFailed: "Oivallusten lataus epäonnistui. Yritä myöhemmin uudelleen.",
  dismissInsight: "Hylkää {{type}}-oivallus",
  insightType: {
    trend_observation: "Trendi",
    pattern_identification: "Malli",
    correlation_observation: "Havainto",
    progress_indicator: "Edistyminen",
    focus_suggestion: "Ehdotus",
  },

  // Quick actions card
  quickActions: "Pikatoiminnot",
  dismissAction: "Hylkää {{title}}",
  quickAction: {
    prepareAppointmentTitle: "Valmistaudu vastaanotolle",
    prepareAppointmentDescription: "Luo yhteenveto lääkärikäyntiä varten",
    addCheckInTitle: "Lisää päivän kirjaus",
    addCheckInDescription: "Kirjaa tämänhetkinen vointisi",
    voiceCheckInTitle: "Äänikirjaus",
    voiceCheckInDescription: "Kuvaile oireesi puhumalla",
    aiCheckInTitle: "AI-kirjaus",
    aiCheckInDescription: "Kirjaa kipusi keskustelemalla tekoälyn kanssa",
    viewTrendsTitle: "Tarkastele trendejä",
    viewTrendsDescription: "Näe kiputietojesi kehitys",
    logEventTitle: "Kirjaa tapahtuma",
    logEventDescription: "Kirjaa lääkemuutos, toimenpide tai virstanpylväs",
    setUpRemindersTitle: "Ota muistutukset käyttöön",
    setUpRemindersDescription: "Saa päivittäiset muistutukset kipukirjauksiin",
    addMedicationsTitle: "Lisää lääkitykset",
    addMedicationsDescription: "Seuraa lääkityksiä ja niiden vaikutusta kipuun",
    completeProfileTitle: "Täydennä profiilisi",
    completeProfileDescription: "Lisää tietoja paremman kipuanalyysin tueksi",
    exportDataTitle: "Vie tietosi",
    exportDataDescription: "Lataa kipuhistoriasi lääkärikäyntiä varten",
  },

  // Primary actions bar
  primaryActions: "Ensisijaiset toiminnot",
  primaryAction: {
    addCheckIn: "Kirjaus",
    addEvent: "Tapahtuma",
    prepareAppointment: "Vastaanotto",
    addCheckInLong: "Lisää kipukirjaus",
    addEventLong: "Lisää terveystapahtuma",
    prepareAppointmentLong: "Valmistaudu lääkärikäyntiin",
    helpStartTracking: "Aloita seuranta valmistautuaksesi vastaanotoille",
    helpDaysRemaining_one: "{{count}} seurantapäivä lisää parempiin oivalluksiin",
    helpDaysRemaining_other: "{{count}} seurantapäivää lisää parempiin oivalluksiin",
  },

  // Recent events card
  recentEvents: "Viimeaikaiset tapahtumat",
  viewAll: "Näytä kaikki",
  logFirstEvent: "Kirjaa ensimmäinen tapahtuma",
  ongoing: "Käynnissä",
  positiveMilestonesThisMonth_one: "{{count}} positiivinen virstanpylväs tässä kuussa",
  positiveMilestonesThisMonth_other: "{{count}} positiivista virstanpylvästä tässä kuussa",

  // Today summary card
  noCheckInsToday: "Ei kirjauksia tänään",
  howAreYouFeeling: "Miltä sinusta tuntuu tänään?",
  addCheckIn: "Lisää kirjaus",
  lastCheckIn: "Viimeisin kirjaus: {{time}}",
  locationSingular: "Sijainti",
  locationPlural: "Sijaintia",
  avgIntensity: "Keskiarvovoimakkuus",

  // Today status banner
  todayStatusBanner: {
    default: {
      text: "Et ole vielä kirjannut tänään",
      cta: "Kirjaa vointisi",
      ariaLabel: "Muistutus: et ole vielä kirjannut tänään. Napauta lisätäksesi kipukirjauksen",
    },
    casual: {
      text: "Miltä sinusta tuntuu tänään?",
      cta: "Lisää päivän kirjaus",
      ariaLabel: "Miltä sinusta tuntuu tänään? Napauta lisätäksesi kipukirjauksen",
    },
  },

  // Week summary card
  noDataYet: "Ei dataa vielä",
  avg: "Keskiarvo: {{value}}",
  avgNoData: "Keskiarvo: —",
  daysLogged: "{{logged}}/{{total}} päivää kirjattu",

  // Dashboard empty state
  welcomeUser: "Tervetuloa Flolineen, {{name}}",
  welcomeGeneric: "Tervetuloa Flolineen",
  emptyStateDescription: "Seuraa kipuasi löytääksesi kuvioita ja jaa oivalluksia lääkärisi kanssa.",
  startFirstCheckIn: "Aloita ensimmäinen kirjaus",
  emptyStateGuidance: "Kirjaa kipukohteet, voimakkuus ja mahdolliset lääkityksesi",
} as const;
